import {css, StyleSheet} from "aphrodite";
import * as React from "react";

import {color, spacing} from "@khanacademy/wonder-blocks-tokens";
import {borderRadius} from "@khan/shared-styles";

type Props = {
    onClassCodeChange: (arg1: string) => void;
};

type State = {
    classCode: string;
    focused: boolean;
};

class ClassCodeInput extends React.Component<Props, State> {
    classCodeInput: HTMLInputElement | null | undefined;
    state: State = {
        classCode: "",
        focused: false,
    };

    handleClassCodeChange: (e: React.SyntheticEvent<EventTarget>) => void = (
        e: React.SyntheticEvent<any>,
    ) => {
        if (e.target instanceof HTMLInputElement) {
            const classCode = e.target.value;

            this.setState({
                classCode,
            });
            this.props.onClassCodeChange(classCode);

            if (classCode.length === 8) {
                this.classCodeInput && this.classCodeInput.blur();
            }
        }
    };

    handleFocus: () => void = () => {
        this.setState({focused: true});
    };
    handleBlur: () => void = () => {
        this.setState({focused: false});
    };

    render(): React.ReactNode {
        const {classCode, focused} = this.state;
        const borderColorStyle = focused ? color.blue : color.offBlack50;
        const border = `1px solid ${borderColorStyle}`;

        return (
            // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions -- TODO: Address a11y error
            <form
                className={css(styles.container)}
                style={{border}}
                onFocus={this.handleFocus}
                onBlur={this.handleBlur}
            >
                <input
                    maxLength={8}
                    className={css(styles.input)}
                    value={classCode}
                    onChange={this.handleClassCodeChange}
                    ref={(node) => (this.classCodeInput = node)}
                />
            </form>
        );
    }
}

const styles = StyleSheet.create({
    input: {
        fontSize: "40px",
        fontWeight: "normal",
        lineHeight: "40px",
        fontFamily: "'Inconsolata', monospace",
        outline: "none",
        // To fix a Firefox bug where the input is not the full width of the
        // container
        width: "100%",
        color: "inherit",
        boxShadow: "none",
        textTransform: "uppercase",
        border: "none",
        letterSpacing: 20,
        overflow: "hidden",
        marginLeft: 6,
        marginRight: -9,
        // Adds the dashed underline to the input
        backgroundColor: "transparent",
        backgroundImage: "linear-gradient(to right, gray 68%, transparent 32%)",
        backgroundSize: "44px 1px",
        backgroundRepeat: "repeat-x",
        backgroundPosition: "bottom left",
    },
    container: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-evenly",
        alignItems: "center",
        marginBottom: 0,
        height: 64,
        minWidth: 360,
        borderRadius,
        boxSizing: "border-box",
        padding: spacing.xSmall_8,
        backgroundColor: "transparent",
    },
});

export default ClassCodeInput;
